import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import AutoService from './auth.service';
import LangService from './lang.service';
import { API_URL } from '../../config/env';

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },

  setHeader() {
    var token = AutoService.getToken()
    if (token) {
      Vue.axios.defaults.headers.common['X-ACCESS-TOKEN'] = token;
    }
    Vue.axios.defaults.headers.common['Accept-Language'] = LangService.getLang();
  },

  query(resource, params) {
    return Vue.axios
      .get(resource, params)
      .catch((error) => {
        throw new Error(`ApiService ${error}`);
      });
  },

  get(resource, slug = '') {
    return Vue.axios
      .get(`${resource}/${slug}`)
      .catch((error) => {
        throw error;
      });
  },

  post(resource, params) {
    return Vue.axios
      .post(`${resource}`, params);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios
      .put(`${resource}`, params);
  },

  delete(resource, params) {
    return Vue.axios
      .delete(`${resource}`, params)
      .catch((error) => {
        throw new Error(`ApiService ${error}`);
      });
  },
};

export default ApiService;



// WEBPACK FOOTER //
// ./src/services/api.service.js